import script from "./DesktopMySpace.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopMySpace.vue?vue&type=script&setup=true&lang=js"

import "./DesktopMySpace.vue?vue&type=style&index=0&id=2c241373&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c241373"]])

export default __exports__